import React from 'react';
import { ListItem } from './styled';
import { MopDisplayContent } from './MopDisplayContent';
import { DataTestAttributes } from '../../../constants/DataTestAttributes';
var MopListItem = function MopListItem(props) {
  var mop = props.mop,
    onClick = props.onClick,
    isCheckoutPage = props.isCheckoutPage;
  var cardIdHash = mop.cardIdHash,
    last4 = mop.last4;
  var creditCardDescriptionDataTest = "".concat(DataTestAttributes.EXISTING_CARD_CONTAINER, "-").concat(last4);
  return /*#__PURE__*/React.createElement(ListItem, {
    "data-test": "".concat(last4 ? creditCardDescriptionDataTest : DataTestAttributes.EXISTING_PAYPAL_DESCRIPTION),
    onClick: onClick
  }, /*#__PURE__*/React.createElement(MopDisplayContent, {
    mop: mop,
    ariaDescribedById: cardIdHash,
    isCheckoutPage: isCheckoutPage
  }));
};
export default /*#__PURE__*/React.memo(MopListItem);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/Recurly/MopListView/MopListItem.js
// module id = 4640
// module chunks = 11